import { useParams } from "react-router-dom";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { ChatLayout } from "../components/ChatLayout";
import { ChatSessionProvider } from "../context/ChatSessionProvider";
import { CitationProvider } from "../context/CitationProvider";
import { AGENT_CONFIG_PATH } from "../types";

export const ChatPage = () => {
  const { sessionId } = useParams<{ sessionId?: string }>();
  useDocumentTitle("Home");

  // StreamsProvider is hoisted to <App> so the persistent rail's Recents list
  // can read streaming state on every route.
  return (
    <ChatSessionProvider
      sessionId={sessionId}
      agentConfigPath={AGENT_CONFIG_PATH}
      routeBase="/chat"
    >
      <CitationProvider>
        <ChatLayout />
      </CitationProvider>
    </ChatSessionProvider>
  );
};
